export const LOCALES = {
    ENGLISH: "en",
    GERMAN: "de",
    // ENGLISH: "en-US",
    // GERMAN: "de-DE",
  };